import styled, { css } from 'styled-components'
import { fontSizeS, fontWeightL, fontWeightS, ColorGreyDark } from '../styles/sharedStyles';

const Tooltip = styled.div`
    pointer-events: none;
    user-select: none;
    white-space: nowrap;
    visibility: ${props => props.visible ? 'visible' :  'hidden'};
    color: ${ColorGreyDark};

    position: ${props => props.fixed ? 'fixed' : "absolute"};
    top: ${props => props.top}px;
    left: ${props => props.left}px;

    filter: drop-shadow(.5px .5px 1.5px rgba(51,51,51,.2));

    background: #fff;
    z-index: 15;

    padding: .5rem 1rem;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;

    font-size: ${fontSizeS};

    &:after {
        ${props => props.position === 'left' 
        ? css`
            left: 100%;
            top: 50%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: rgba(136, 183, 213, 0);
            border-left-color: #fff;
            border-width: 1rem;
            margin-top: -1rem;
        ` : props.position === 'right' ?  css`
            right: 100%;
            top: 50%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: rgba(136, 183, 213, 0);
            border-right-color: #fff;
            border-width: 1rem;
            margin-top: -1rem;
        ` : css`
            top: 100%;
            left: 1.5rem;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: rgba(136, 183, 213, 0);
            border-top-color: #fff;
            border-width: 1rem;
            margin-left: -1rem;
        `}


    

    }

    .title {
        font-weight: ${fontWeightL};
        margin-bottom: .5rem;
    }

    .value {

        display: flex;
        align-items: flex-end;

       &__text {
           font-weight: ${fontWeightS};
       } 

       &__value {
        font-weight: ${fontWeightL};
       }

    }
`


export default Tooltip